import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  getBillingShippingAddress,
  profilePostAction,
} from "../../actions/profileAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { states } from "../../constants/states";
import { getUserDetail } from "../../utils/helper";
const AddressPopup = ({ closePopup, addressInfo, setListChanged }) => {
  const dispatch = useDispatch();
  const appLoading = useSelector((state) => state.alert.appLoading);
  const initialValues = {
    firstname: addressInfo && addressInfo.first_name,
    lastname: addressInfo && addressInfo.last_name,
    email: addressInfo && addressInfo.email,
    address_1: addressInfo && addressInfo.address_1,
    address_2: addressInfo && addressInfo.address_2,
    city: addressInfo && addressInfo.city,
    state: addressInfo && addressInfo.state,
    phone: addressInfo && addressInfo.phone,
    zip: addressInfo && addressInfo.zip,
    addressNickname: addressInfo && addressInfo.address_nickname,
  };

  const validationSchema = Yup.object({
    firstname: Yup.string().nullable().required("This field is required"),
    lastname: Yup.string().nullable().required("This field is required"),
    email: Yup.string().nullable().email().required("This field is required"),
    phone: Yup.string()
      .nullable()
      .min(10, "Phone number must be 10 digits long")
      .max(10, "Phone number must be 10 digits long")
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Phone number is not valid"
      )
      .required("This field is required"),
    address_1: Yup.string().nullable().required("This field is required"),
    city: Yup.string().nullable().required("This field is required"),
    state: Yup.string().nullable().required("This field is required"),
    zip: Yup.string()
      .nullable()
      .max(5)
      .min(5)
      .matches(/^\d{5}$/, "Zip code is not valid")
      .required("This field is required"),
    addressNickname: Yup.string().nullable(),
  });

  const onSubmit = (values) => {
    const data = {
      first_name: values.firstname,
      last_name: values.lastname,
      email: values.email,
      address_1: values.address_1,
      address_2: values.address_2,
      address_id: addressInfo && addressInfo.address_id,
      city: values.city,
      state: { value: values.state },
      phone: values.phone,
      zip: values.zip,
      address_nickname:
        values.addressNickname === "" ? null : values.addressNickname,
    };
    var actionName =
      addressInfo != null
        ? "userEditBillingShipping"
        : "userAddBillingShipping";
    var params = {
      params: {
        action: actionName,
        data: data,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      profilePostAction(params, () => {
        dispatch(
          getBillingShippingAddress(() => {
            setListChanged(true);
          })
        );

        closePopup();
      })
    );
  };
  return (
    <Modal size="lg" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Address information</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ errors, touched, setFieldValue, handleBlur }) => {
              return (
                <Form>
                  <div className="row">
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* First Name"
                        name="firstname"
                        handleBlur={handleBlur}
                        hasError={errors.firstname && touched.firstname}
                      />
                    </div>
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Last Name"
                        handleBlur={handleBlur}
                        name="lastname"
                        hasError={errors.lastname && touched.lastname}
                      />
                    </div>
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Email"
                        name="email"
                        handleBlur={handleBlur}
                        hasError={errors.email && touched.email}
                      />
                    </div>
                    <div className="col-sm-8">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Street Address"
                        name="address_1"
                        handleBlur={handleBlur}
                        hasError={errors.address_1 && touched.address_1}
                      />
                    </div>
                    <div className="col-sm-4">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="Apt"
                        handleBlur={handleBlur}
                        name="address_2"
                        hasError={errors.address_2 && touched.address_2}
                      />
                    </div>
                    <div className="col-sm-8">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* City"
                        handleBlur={handleBlur}
                        name="city"
                        hasError={errors.city && touched.city}
                      />
                    </div>
                    <div className="col-sm-4">
                      <FormikControl
                        control="dropdown"
                        label="State"
                        name="state"
                        handleBlur={handleBlur}
                        hasError={errors.state && touched.state}
                        options={states}
                      />
                    </div>
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="* Phone"
                        name="phone"
                        handleBlur={handleBlur}
                        maxLength={10}
                        onPaste={(e) => {
                          const str = e.clipboardData.getData("Text");
                          let newStr = str.replace(/[^0-9]/g, "");
                          if (newStr.length > 10 && newStr[0] == 1) {
                            newStr = newStr.slice(1);
                          }
                          if (str !== newStr) {
                            e.preventDefault();
                            setFieldValue("phone", newStr);
                          }
                        }}
                        hasError={errors.phone && touched.phone}
                      />
                    </div>
                    <div className="col-sm-6">
                      <FormikControl
                        control="forminput"
                        type="text"
                        handleBlur={handleBlur}
                        label="* Zip code"
                        name="zip"
                        maxLength={5}
                        hasError={errors.zip && touched.zip}
                      />
                    </div>
                    <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="text"
                        label="Address Description"
                        handleBlur={handleBlur}
                        name="addressNickname"
                        hasError={
                          errors.addressNickname && touched.addressNickname
                        }
                      />
                    </div>
                  </div>
                  <div className="submit-section mt-2">
                    <button
                      className="btn-orange"
                      type="submit"
                      disabled={appLoading}
                    >
                      Save
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default AddressPopup;
